import { createContext } from 'react';
import type { UserRole } from '@/types/user';

export interface AuthUser {
  userId: string;
  displayName: string;
  role: UserRole;
  roles?: string[];
  canRegisterTimeForOthers: boolean;
  leaveOverviewMinimumRole: UserRole;
  leaveOverviewAllowCompanyScope: boolean;
}

export const AuthContext = createContext<AuthUser | null>(null);
